import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { Assessment } from '@shared/models/records/assessment.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-assessment-result-card',
  templateUrl: './assessment-result-card.component.html',
  styleUrls: ['./assessment-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AssessmentResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;
    isSingleClick: Boolean = true;     

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new Assessment(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get fileId() {
        return this.record.file_id;
    }

    get primaryTownship(): any[] {
        return this.record.primary_township;
    }

    get year() {
        if(this.record.year_from != 0 && this.record.year_to != 0) {
            if(this.record.year_from == this.record.year_to) {
                return this.record.year_from;
            } else {
                return this.record.year_from + " - " + this.record.year_to;
            }
        }
        return null;
    }

    get yearFrom() {
        return this.record.year_from;
    }

    get yearTo() {
        return this.record.year_to;
    }

    get performedFor() {
        return this.record.performed_for;
    }

    get workTypes() {
        return this.record.work_types;
    }

    openInSameTab() {
        this.isSingleClick = true;
        setTimeout(()=>{
            if(this.isSingleClick){
                this.router.navigate(['/assessment', this.fileId], { state: { data: this.record, searchTerms: this.searchTerms} });
            }
         }, 250)
     }
 
     openInNewTab() {
        this.isSingleClick = false;
        var target = environment.application_url + "persistent-linking?" + DatabaseIndexNameType.assessment + "=" + this.fileId;
        this.router.navigate([], { state: { data: this.record, searchTerms: this.searchTerms} }).then(() => {  window.open(target, '_blank'); });
      }

}